import { Metadata } from "./components/metadata/Metadata";
import { OfficeLocation } from "./components/metadata/OfficeLocation";
import { Region } from "./components/metadata/Region";
import { BusinessUnit } from "./components/metadata/BusinessUnit";
import { CompanyType } from "./components/metadata/CompanyType";
import { Country } from "./components/metadata/Country";

import AboutUs from "./components/AboutUs";
import Application from "./components/application/Application";
import EmailList from "./components/email/EmailList";
import Home from "./components/Home";
import LogIn from "./components/Login";
import UmCompany  from "./components/company/UmCompany";
import UserGroup  from "./components/group/UserGroup";
import UserList from "./components/user/UserList";
import WorkflowMonitor from "./components/task/WorkflowMonitor/WorkflowMonitor";
import CompanyRequest from "./components/task/CompanyRequest/CompanyRequest";
import SecureRoute from "./utils/SecureRoute";
import UserRevalidation from "./components/revalidation/UserRevalidation";
import AppApproval from "./components/application/AppApproval";
import ApprovalDelegation from "./components/ApprovalDelegation/ApprovalDelegation";
import EmailTemplate from "./components/email/EmailTemplate";
import RelatedApplication from "./components/task/RelatedApplication/RelatedApplication";
import UpdateEmails from "./components/task/UpdateEmails/UpdateEmails";

const AppRoutes = [
    {
        index: true,
        element: <SecureRoute><Home /></SecureRoute>
    },
    {
        path: '/',
        element: <SecureRoute><Home /></SecureRoute>
    },
    {
        path: '/aboutus',
        element: <SecureRoute><AboutUs /></SecureRoute>
    },
    {
        path: '/country',
        element: <SecureRoute><Country /></SecureRoute>
    },
    {
        path: '/region',
        element: <SecureRoute><Region /></SecureRoute>
    },
    {
        path: '/metadata',
        element: <SecureRoute><Metadata /></SecureRoute>
    },
    {
        path: '/companytype',
        element: <SecureRoute><CompanyType /></SecureRoute>
    },
    {
        path: '/businessunit',
        element: <SecureRoute><BusinessUnit /></SecureRoute>
    },
    {
        path: '/officelocation',
        element: <SecureRoute><OfficeLocation /></SecureRoute>
    },
    {
        path: '/application',
        element: <SecureRoute><Application /></SecureRoute>
    },
    {
        path: '/company',
        element: <SecureRoute><UmCompany /></SecureRoute>
    },
    {
        path: '/login',
        element: <LogIn />
    },
    {
        path: '/userlist',
        element: <SecureRoute><UserList /></SecureRoute>
    },
    {
        path: '/emailtemplate',
        element: <SecureRoute><EmailTemplate /></SecureRoute>
    },
    {
        path: '/umemails',
        element: <SecureRoute><EmailList /></SecureRoute>
    },
    {
        path: '/usergroups',
        element: <SecureRoute><UserGroup /></SecureRoute>
    },
    {
        path: '/workflowmonitor',
        element: <SecureRoute><WorkflowMonitor /></SecureRoute>
    },
    {
        path: '/companyrequest',
        element: <SecureRoute><CompanyRequest /></SecureRoute>
    },
    {
        path: '/revalidationsetup',
        element: <SecureRoute><UserRevalidation /></SecureRoute>
    },
    {
        path: '/approver',
        element: <SecureRoute><AppApproval /></SecureRoute>
    },
    {
        path: '/approverdelegation',
        element: <SecureRoute><ApprovalDelegation /></SecureRoute>
    },
    {
        path: '/relatedapplication',
        element: <SecureRoute><RelatedApplication /></SecureRoute>
    },
    {
        path: '/updateemails',
        element: <SecureRoute><UpdateEmails /></SecureRoute>
    }
]; 

export default AppRoutes;
